import { EventBus } from "@saas/components/src/utils/event-bus";
import Vue from "vue";
import VueRouter from "vue-router";
import store from "@saas/store/src/index.js";
import { getUserInfo } from "@saas/server-api/src";
import { isHXApp, isMobile, pageShare } from "@saas/components/src/utils/utils";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import types from "@saas/store/src/types.js";
import { setToken } from "@saas/server-api/src/plugins/auth";
import { deprecatedRoutes } from "./deprecated-routes";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "Home" */ "@saas/pages/src/home/Index.vue"),
    meta: {
      routeTitle: "首页",
      showConsultEntry: true,
    },
  },
  {
    path: "/about",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "About" */ "@saas/pages/src/home/About.vue"),
    meta: {
      routeTitle: "关于我们",
      noNavBar: true,
      showConsultEntry: true,
    },
  },
  {
    path: "/org-settled",
    name: "OrgSettled",
    component: () =>
      import(
        /* webpackChunkName: "OrgSettled" */ "@saas/pages/src/org-settled/Index.vue"
      ),
    meta: {
      routeTitle: "机构入驻",
      noNavBar: true,
      showConsultEntry: true,
    },
  },
  {
    path: "/contact",
    name: "Contact",
    component: () =>
      import(
        /* webpackChunkName: "Contact" */ "@saas/pages/src/home/Contact.vue"
      ),
    meta: {
      routeTitle: "联系我们",
    },
  },
  {
    path: "/learning-center",
    name: "LearningCenter",
    component: () =>
      import(
        /* webpackChunkName: "LearningCenter" */ "@saas/pages/src/learning-center/Index.vue"
      ),
    redirect: "/my-course",
    meta: {
      routeTitle: "学习中心",
      showConsultEntry: true,
    },
    children: [
      {
        path: "/my-course",
        name: "myCourse",
        component: () =>
          import(
            /* webpackChunkName: "myCourse" */ "@saas/pages/src/learning-center/my-course/Index.vue"
          ),
        meta: {
          requireAuth: true,
          routeTitle: "我的课程",
          showConsultEntry: true,
        },
      },
      {
        path: "/live-calendar",
        name: "liveCalendar",
        component: () =>
          import(
            /* webpackChunkName: "liveCalendar" */ "@saas/pages/src/learning-center/live-calendar/Index.vue"
          ),
        meta: {
          requireAuth: true,
          routeTitle: "直播日历",
          showConsultEntry: true,
        },
      },
      {
        path: "/course-detail/:id",
        name: "myCourseDetail",
        component: () =>
          import(
            /* webpackChunkName: "myCourseDetail" */ "@saas/pages/src/learning-center/course-detail/Index.vue"
          ),
        meta: {
          requireAuth: true,
          routeTitle: "课程详情",
          showConsultEntry: true,
        },
      },
    ],
  },
  {
    path: "/trade",
    name: "Trade",
    component: () =>
      import(
        /* webpackChunkName: "Trade" */ "@saas/pages/src/learning-center/trade/Index.vue"
      ),
    meta: {
      requireAuth: true,
      routeTitle: "交易",
      // keepAlive: true,
      showConsultEntry: true,
    },
  },
  // {
  //   path: "/replay/:courseId/:unitId/:lessonId",
  //   name: "Replay",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "replay" */ "@saas/pages/src/learning-center/replay/Index.vue"
  //     ),
  //   meta: {
  //     routeTitle: "回放",
  //     requireAuth: true,
  //     nofooter: true,
  //     noNavBar: true,
  //     noOpenApp: true,
  //     // keepAlive: isHXApp(),
  //   },
  // },
  {
    path: "/video-play/:courseId/:unitId/:lessonId",
    name: "VideoPlay",
    component: () =>
      import(
        /* webpackChunkName: "VideoPlay" */ "@saas/pages/src/video-play/Index.vue"
      ),
    meta: {
      routeTitle: "视频播放",
      requireAuth: false,
      nofooter: false,
      noNavBar: true,
      // keepAlive: isHXApp(),
    },
  },
  {
    path: "/teacher",
    name: "Teacher",
    component: () =>
      import(
        /* webpackChunkName: "Teacher" */ "@saas/pages/src/teacher/Index.vue"
      ),
    redirect: "/live-list",
    meta: {
      routeTitle: "授课",
    },
    children: [
      {
        path: "/live-list",
        name: "LiveList",
        component: () =>
          import(
            /* webpackChunkName: "LiveList" */ "@saas/pages/src/teacher/live-list/Index.vue"
          ),
        meta: {
          requireAuth: true,
          routeTitle: "课表",
          noOpenApp: true,
        },
      },
      {
        path: "/t-courses",
        name: "TCourses",
        component: () =>
          import(
            /* webpackChunkName: "TCourses" */ "@saas/pages/src/teacher/course-list/Index.vue"
          ),
        meta: {
          requireAuth: true,
          routeTitle: "课程",
          noOpenApp: true,
        },
      },
      {
        path: "/t-course-detail/:id",
        name: "TCourseDetail",
        component: () =>
          import(
            /* webpackChunkName: "TCourseDetail" */ "@saas/pages/src/teacher/course-detail/Index.vue"
          ),
        meta: {
          requireAuth: true,
          routeTitle: "课程详情",
          noOpenApp: true,
        },
      },
    ],
  },
  {
    path: "/course-list",
    name: "CourseList",
    component: () =>
      import(
        /* webpackChunkName: "CourseList" */ "@saas/pages/src/course-list/Index.vue"
      ),
    meta: {
      routeTitle: "课程",
    },
  },
  {
    path: "/search-result",
    name: "SearchResult",
    component: () =>
      import(
        /* webpackChunkName: "SearchResult" */ "@saas/pages/src/search-result/Index.vue"
      ),
    meta: {
      routeTitle: "搜索结果",
      noOpenApp: true,
    },
  },
  {
    path: "/user-info",
    name: "UserInfo",
    component: () =>
      import(
        /* webpackChunkName: "UserInfo" */ "@saas/pages/src/user-info/Index.vue"
      ),
    meta: {
      requireAuth: true,
      routeTitle: "个人信息",
    },
  },
  ...deprecatedRoutes,
  {
    path: "/invite/:inviteId",
    name: "Invite",
    component: () =>
      import(
        /* webpackChunkName: "Invite" */ "@saas/pages/src/invite/Index.vue"
      ),
    meta: {
      requireAuth: true,
      routeTitle: "邀请",
      noOpenApp: true,
    },
  },
  {
    path: "/org/:org_id",
    name: "Organization",
    component: () =>
      import(
        /* webpackChunkName: "Organization" */ "@saas/pages/src/organization/Index.vue"
      ),
    meta: {
      routeTitle: "机构主页",
      noNavBar: true,
    },
  },
  {
    path: "/org-courses/:org_id",
    name: "OrganizationCourses",
    component: () =>
      import(
        /* webpackChunkName: "OrganizationCourses" */ "@saas/pages/src/organization-courses/Index.vue"
      ),
    meta: {
      routeTitle: "课程",
    },
  },
  {
    path: "/product-detail/:id",
    name: "ProductDetails",
    component: () =>
      import(
        /* webpackChunkName: "ProductDetails" */ "@saas/pages/src/product-details/Index.vue"
      ),
    meta: {
      routeTitle: "商品详情",
      nofooter: true,
      noNavBar: true,
      // notShowAppNav: true,
    },
  },
  {
    path: "/course/invite/:id",
    name: "CourseInvite",
    component: () =>
      import(
        /* webpackChunkName: "CourseInvite" */ "@saas/pages/src/course-invite/Index.vue"
      ),
    meta: {
      routeTitle: "课程邀请",
      nofooter: true,
      noNavBar: true,
      noOpenApp: true,
      // notShowAppNav: true,
    },
  },
  {
    path: "/confirm-order/:order_no",
    name: "ConfirmOrder",
    component: () =>
      import(
        /* webpackChunkName: "ConfirmOrder" */ "@saas/pages/src/confirm-order/Index.vue"
      ),
    meta: {
      routeTitle: "确认订单",
      requireAuth: true,
      nofooter: true,
    },
  },
  {
    path: "/payment/:order_no",
    name: "Payment",
    component: () =>
      import(
        /* webpackChunkName: "Payment" */ "@saas/pages/src/payment/Index.vue"
      ),
    meta: {
      routeTitle: "支付中心",
      requireAuth: true,
      nofooter: true,
    },
  },
  {
    path: "/pay-result/:order_no",
    name: "PayResult",
    component: () =>
      import(
        /* webpackChunkName: "PayResult" */ "@saas/pages/src/pay-result/Index.vue"
      ),
    meta: {
      routeTitle: "支付结果",
      requireAuth: true,
      nofooter: isMobile(),
    },
  },
  {
    path: "/coupon-detail/:id",
    name: "CouponDetail",
    component: () =>
      import(
        /* webpackChunkName: "CouponDetail" */ "@saas/pages/src/coupon-detail/Index.vue"
      ),
    meta: {
      routeTitle: "优惠券",
      requireAuth: true,
    },
  },
  {
    path: "/download",
    name: "Download",
    component: () =>
      import(
        /* webpackChunkName: "Download" */ "@saas/pages/src/download/Index.vue"
      ),
    meta: {
      routeTitle: "下载",
      showConsultEntry: true,
      noOpenApp: true,
      // background:
      //   "linear-gradient( 180deg, #E7F3EB 0%, #FFFFFF 100%, #FFFFFF 100%)",
      navBarBackgroud: "rgba(241, 248, 243, 1)",
    },
  },
  {
    path: "/details/:id",
    name: "Details",
    component: () =>
      import(
        /* webpackChunkName: "Details" */ "@saas/pages/src/details/Index.vue"
      ),
    meta: {
      routeTitle: "详情",
    },
  },
  {
    path: "/homework/:id",
    name: "Homework",
    component: () =>
      import(
        /* webpackChunkName: "Homework" */ "@saas/pages/src/homework/Index.vue"
      ),
    meta: {
      requireAuth: true,
      routeTitle: "作业",
      noNavBar: true,
      nofooter: true,
      noOpenApp: true,
      notShowAppNav: true,
    },
  },
  {
    path: "/homework-custom/:id",
    name: "HomeworkCustom",
    component: () =>
      import(
        /* webpackChunkName: "HomeworkCustom" */ "@saas/pages/src/homework-custom/Index.vue"
      ),
    meta: {
      requireAuth: true,
      routeTitle: "自定义作业",
      nofooter: true,
      noOpenApp: true,
      notShowAppNav: true,
    },
  },
  {
    path: "/joint-purchase/:union_id",
    name: "JointPurchase",
    component: () =>
      import(
        /* webpackChunkName: "JointPurchase" */ "@saas/pages/src/joint-purchase/Index.vue"
      ),
    meta: {
      routeTitle: "联报",
      noNavBar: true,
      nofooter: true,
    },
  },
  {
    path: "/group-share/:id",
    name: "groupShare",
    component: () =>
      import(
        /* webpackChunkName: "groupShare" */ "@saas/pages/src/group-activity/share/Index.vue"
      ),
    meta: {
      routeTitle: "拼团分享页",
      noNavBar: true,
      nofooter: true,
    },
  },
  {
    path: "/group-info/:id",
    name: "groupInfo",
    component: () =>
      import(
        /* webpackChunkName: "groupInfo" */ "@saas/pages/src/group-activity/group-info/Index.vue"
      ),
    meta: {
      routeTitle: "拼团详情页",
      noNavBar: true,
      nofooter: true,
      requireAuth: true,
    },
  },
  {
    path: "/group-rule",
    name: "groupRule",
    component: () =>
      import(
        /* webpackChunkName: "groupRule" */ "@saas/pages/src/group-activity/Rule.vue"
      ),
    meta: {
      routeTitle: "拼团活动规则",
      layout: "agreement-page",
      noNavBar: true,
      nofooter: true,
    },
  },
  {
    path: "/comment/:course_id",
    name: "Comment",
    component: () =>
      import(
        /* webpackChunkName: "comment" */ "@saas/pages/src/comment/Write.vue"
      ),
    meta: {
      routeTitle: "写评价",
      noNavBar: true,
      nofooter: true,
    },
  },
  {
    path: "/comment-edit/:comment_id",
    name: "EditComment",
    component: () =>
      import(
        /* webpackChunkName: "comment" */ "@saas/pages/src/comment/Write.vue"
      ),
    meta: {
      routeTitle: "编辑评价",
      noNavBar: true,
      nofooter: true,
    },
  },
  {
    path: "/comment-info/:comment_id",
    name: "CommentInfo",
    component: () =>
      import(
        /* webpackChunkName: "comment" */ "@saas/pages/src/comment/Info.vue"
      ),
    meta: {
      routeTitle: "评价详情",
      noNavBar: true,
      nofooter: true,
    },
  },
  {
    path: "/comment-complete/:comment_id",
    name: "CommentComplete",
    component: () =>
      import(
        /* webpackChunkName: "CommentComplete" */ "@saas/pages/src/comment/CommentComplete.vue"
      ),
    meta: {
      routeTitle: "评价完成",
      noNavBar: true,
      nofooter: true,
    },
  },
  {
    path: "/comment-list",
    name: "CommentList",
    component: () =>
      import(
        /* webpackChunkName: "CommentList" */ "@saas/pages/src/comment/CommentList.vue"
      ),
    meta: {
      routeTitle: "课程评价",
      noNavBar: true,
      nofooter: true,
      keepAlive: true,
      requireAuth: true,
      noOpenApp: true,
    },
  },
  {
    path: "/exchange",
    name: "Exchange",
    component: () =>
      import(
        /* webpackChunkName: "Exchange" */ "@saas/pages/src/exchange/Index.vue"
      ),
    meta: {
      routeTitle: "课程兑换",
    },
  },
  // {
  //   path: "/exchange-result:id",
  //   name: "ExchangeResult",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "ExchangeResult" */ "@saas/pages/src/exchange/Success.vue"
  //     ),
  //   meta: {
  //     routeTitle: "课程兑换",
  //   },
  // },
  {
    path: "/msg-list",
    name: "MsgList",
    component: () =>
      import(
        /* webpackChunkName: "MsgList" */ "@saas/pages/src/message/List.vue"
      ),
    meta: {
      routeTitle: "通知小助手",
      noNavBar: true,
      nofooter: true,
      requireAuth: true,
    },
  },
  {
    path: "/t/:user_id",
    name: "TeacherHome",
    component: () =>
      import(
        /* webpackChunkName: "TeacherHome" */ "@saas/pages/src/teacher-home/Index"
      ),
    meta: {
      routeTitle: "教师主页",
      noNavBar: true,
    },
  },
  {
    path: "/download-app",
    name: "DownloadApp",
    component: () =>
      import(
        /* webpackChunkName: "DownloadApp" */ "@saas/pages/src/download-app/Index"
      ),
    meta: {
      routeTitle: "魔果云课下载页",
      noNavBar: true,
      nofooter: true,
      noOpenApp: true,
    },
  },
  {
    path: "/live-data/:lesson_id",
    name: "LiveData",
    component: () =>
      import(
        /* webpackChunkName: "LiveData" */ "@saas/pages/src/live-data/Index"
      ),
    meta: {
      routeTitle: "直播数据",
      noNavBar: true,
      nofooter: true,
      requireAuth: true,
      noOpenApp: true,
    },
  },
  {
    path: "/new-live-data/:lesson_id",
    name: "NewLiveData",
    component: () =>
      import(
        /* webpackChunkName: "LiveData" */ "@saas/pages/src/live-data/NewLive"
      ),
    meta: {
      routeTitle: "直播数据",
      noNavBar: true,
      nofooter: true,
      requireAuth: true,
      noOpenApp: true,
    },
  },
  {
    path: "/my-info",
    name: "MyInfo",
    component: () =>
      import(/* webpackChunkName: "MyInfo" */ "../views/my-info/MyInfo.vue"),
    meta: {
      routeTitle: "我的",
      noNavBar: true,
    },
  },
  {
    path: "/my-note",
    name: "MyNote",
    component: () =>
      import(
        /* webpackChunkName: "MyNote" */ "@saas/pages/src/my-note/Index.vue"
      ),
    meta: {
      routeTitle: "我的笔记",
      requireAuth: true,
      nofooter: true,
    },
  },
  {
    path: "/note/:lessonId",
    name: "Note",
    component: () =>
      import(/* webpackChunkName: "Note" */ "@saas/pages/src/note/Index.vue"),
    meta: {
      routeTitle: "笔记",
      requireAuth: true,
      nofooter: true,
      noNavBar: true,
    },
  },
  {
    path: "/note-h5/:courseId/:unitId/:lessonId",
    name: "NoteH5",
    component: () =>
      import(
        /* webpackChunkName: "Note" */ "@saas/pages/src/note-h5/Index.vue"
      ),
    meta: {
      routeTitle: "笔记",
      requireAuth: true,
      nofooter: true,
      noNavBar: true,
      noOpenApp: true,
    },
  },
  // {
  //   path: "/network-test",
  //   name: "NetworkTest",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "NetworkTest" */ "@saas/pages/src/network-test/Index"
  //     ),
  //   meta: {
  //     routeTitle: "网络检测",
  //     noNavBar: true,
  //     nofooter: true,
  //     // requireAuth: true,
  //   },
  // },
  {
    path: "/org-cooperate",
    name: "OrgCooperate",
    component: () =>
      import(
        /* webpackChunkName: "OrgCooperate" */ "@saas/pages/src/protocol/OrgCooperate.vue"
      ),
    meta: {
      routeTitle: "机构服务合作协议",
      layout: "agreement-page",
      nofooter: true,
      noNavBar: true,
      noOpenApp: true,
    },
  },
  {
    path: "/service-agreement",
    name: "ServiceAgreement",
    component: () =>
      import(
        /* webpackChunkName: "ServiceAgreement" */ "@saas/pages/src/protocol/ServiceAgreement.vue"
      ),
    meta: {
      routeTitle: "用户服务协议",
      layout: "agreement-page",
      nofooter: true,
      noNavBar: true,
      noOpenApp: true,
    },
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () =>
      import(
        /* webpackChunkName: "PrivacyPolicy" */ "@saas/pages/src/protocol/PrivacyPolicy.vue"
      ),
    meta: {
      routeTitle: "用户隐私政策",
      layout: "agreement-page",
      nofooter: true,
      noNavBar: true,
      noOpenApp: true,
    },
  },
  {
    path: "/firewall/:courseId",
    name: "Firewall",
    component: () =>
      import(
        /* webpackChunkName: "Firewall" */ "@saas/pages/src/firewall-page/Index.vue"
      ),
    meta: {
      routeTitle: "提示",
      noOpenApp: true,
    },
  },
  {
    path: "/test",
    name: "Test",
    meta: {
      routeTitle: "Test",
      noNavBar: true,
      nofooter: true,
    },
    component: () =>
      import(/* webpackChunkName: "Test" */ "@saas/pages/src/test/Main.vue"),
  },
  {
    path: "/live/:lessonId/:courseId",
    name: "Live",
    component: () =>
      import(
        /* webpackChunkName: "Live" */ "@saas/pages/src/live/WebIndex.vue"
      ),
    meta: {
      routeTitle: "直播",
      requireAuth: true,
      nofooter: true,
      noNavBar: true,
      noOpenApp: true,
    },
  },
  {
    // 小程序同步cookie中间页
    path: "/mini-access",
    name: "mini-access",
    meta: {
      routeTitle: "Test",
      requireAuth: false,
      noNavBar: true,
      noFooter: true,
    },
    component: () =>
      import(/* webpackChunkName: "mini" */ "@saas/pages/src/mini-access/Main"),
  },
  {
    path: "/sentry-test",
    name: "SentryTest",
    meta: {
      routeTitle: "Sentry测试",
      noNavBar: true,
      nofooter: true,
    },
    component: () =>
      import(/* webpackChunkName: "SentryTest" */ "../views/SentryTest.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    meta: {
      routeTitle: "未知",
    },
    component: () =>
      import(
        /* webpackChunkName: "NotFound" */ "@saas/pages/src/error/404.vue"
      ),
  },
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes,
});

router.beforeEach((to, from, next) => {
  // 修改页面标题
  if (isHXApp() && to.meta && to.meta.routeTitle) {
    jsToFlutter("setTitle", { title: to.meta.routeTitle });
  } else {
    if (
      document.title !== "魔果云课 AI教育工具-专业的知识分享和AI在线教育平台"
    ) {
      document.title = "魔果云课 AI教育工具-专业的知识分享和AI在线教育平台";
    }
  }
  if (to.fullPath.startsWith("/live/")) {
    const token = to.query.token;
    if (token) {
      setToken(token);
    }
  }
  if (to.meta?.requireAuth && !store.getters.isAuthenticated && isHXApp()) {
    jsToFlutter("getToken");
    EventBus.$off("setToken");
    EventBus.$on("setToken", (isLogin) => {
      if (isLogin) {
        changeAppNav(to, from, next);
      } else {
        console.log("jsToFlutter===login", isLogin);
        jsToFlutter("login");
      }
    });
  } else if (to.meta?.requireAuth && !store.getters.isAuthenticated) {
    getUserInfo().then((res) => {
      if (res.code === 1) {
        store.commit(types.CHANGE_PROFILE, {
          profile: res.data,
        });
        changeAppNav(to, from, next);
      } else {
        // 未登录
        if (isHXApp()) {
          // app嵌h5登录态处理
          jsToFlutter("getToken");
          EventBus.$off("setToken");
          EventBus.$on("setToken", (isLogin) => {
            if (isLogin) {
              changeAppNav(to, from, next);
            } else {
              console.log("jsToFlutter===login", isLogin);
              jsToFlutter("login");
            }
          });
        } else {
          // let preRoute = from.fullPath === "/" ? to.fullPath : from.fullPath;
          // window.location.href = `${process.env.VUE_APP_ADMIN_URL}/login?return_url=${window.location.origin}${preRoute}`;
          Vue.prototype.$loginDialog({
            to: to.fullPath,
            type: "page",
          });
        }
      }
    });
  } else {
    changeAppNav(to, from, next);
  }
});
router.afterEach(() => {
  // 修改页面标题
  pageShare(window.wx);
});

// app-头部导航显示隐藏处理
const changeAppNav = (to, from, next) => {
  if (isHXApp()) {
    // 不展示app头部---需要记录来源路由
    if (to?.meta?.notShowAppNav) {
      if (to.query.fromName || to.query.fromName === null) {
        console.log("changeNav=======", Boolean(!to?.meta?.notShowAppNav));
        jsToFlutter("changeNav", { isShow: Boolean(!to?.meta?.notShowAppNav) });
        next();
      } else {
        next({
          ...to,
          query: {
            ...to.query,
            fromName: from.name, //来源路由
          },
        });
      }
    } else {
      console.log("changeNav=======", Boolean(!to?.meta?.notShowAppNav));
      jsToFlutter("changeNav", { isShow: Boolean(!to?.meta?.notShowAppNav) });
      next();
    }
  } else {
    next();
  }
};

// 处理路由拦截重定向报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, resolve, reject) {
  if (resolve || reject)
    return originalPush.call(this, location, resolve, reject);
  return originalPush.call(this, location).catch(() => { });
};

export default router;
